<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Ampliados"
            description=""
            url="/indicadores-esb"
          />
        </div>
      </div>
      <div class="row">
        <div class="grid-itens">
          <div v-for="(item, index) in cards" :key="index" class="item-flex">
            <router-link :to="item.link">
              <div class="item">
                <i v-if="item.icone !== false" :class="item.icone"></i>
                <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
                <component v-else :is="item.svg" />
                <h3>
                  {{ item.titulo }}
                </h3>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import SatisfacaoDoCidadao from '@/components/icons/IndicadoresEsb/Ampliados/SatisfacaoDoCidadao'
import Agendamentos72h from '@/components/icons/IndicadoresEsb/Ampliados/Agendamentos72h'
import AtendimentosDomiciliares from '@/components/icons/IndicadoresEsb/Ampliados/AtendimentosDomiciliares'
import Prevencao from '@/components/icons/IndicadoresEsb/Ampliados/Prevencao'

export default {
  name: 'IndicadoresEsbAmpliados',
  components: {
    Menu,
    Footer,
    SectionTitle,
    SatisfacaoDoCidadao,
    Agendamentos72h,
    AtendimentosDomiciliares,
    Prevencao,
  },
  computed: {
    cards() {
      return this.$store.state?.permissoes?.indicadores_esb_ampliados
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
